<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <h1>{{ constants.MANAGE_PROFILE_TEXT }}</h1>
              </div>
            </div>
            <div class="white-bg-border">
              <div class="edit-profile-section">
                <h2>{{ constants.EDIT_PROFILE_TEXT }}</h2>
                <div class="edit-profile-form">
                  <div class="admin-custom-row box-row-2">
                    <div class="admin-input-field">
                      <label>{{ constants.FIRST_NAME_LABEL }}</label>
                      <input id="editProfileFNameInput" type="text" placeholder="" v-model="firstname" />
                      <div class="error-msg" v-if="!firstname">{{errMsg}}</div>
                    </div>
                    <div class="admin-input-field">
                      <label>{{ constants.LAST_NAME_LABEL }}</label>
                      <input id="editProfileLNameInput" type="text" placeholder="" v-model="lastname" />
                      <div class="error-msg" v-if="!lastname">{{errMsg}}</div>
                    </div>
                  </div>
                  <div class="admin-input-field">
                    <label>{{ constants.EMAIL_LABEL }}</label>
                    <input id="editProfileEmailInput" type="email" placeholder="" v-model="email" />
                    <div class="error-msg" v-if="!email">{{errMsg}}</div>
                    <div class="error-msg" v-if="emailError">{{emailError}}</div>
                  </div>
                  <div class="admin-input-field">
                    <label>{{ constants.PROFILE_PICTURE_LABEL }}</label>
                    <div class="admin-upload-profile">
                      <img :src="imageUrl" alt="Profile Picture" />
                      <div class="admin-upload-profile-new">
                        <input id="editProfilePicInput" type="file" @change="handleFileUpload" accept="image/jpeg,image/jpg,image/png" />
                        {{ constants.CHANGE_PICTURE_LABEL }}
                      </div>
                    </div>
                  </div>
                  <div class="admin-input-field-submit">
                    <button id="editProfileSubmitBtn" class="admin-btn-outline-primary" @click="updateProfile">{{ constants.SUBMIT_BUTTON
                      }}</button>
                    <button id="editProfileCancelBtn" class="admin-btn-outline-secondary" @click="cancel">{{ constants.CANCEL_BUTTON }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">{{ constants.COPYRIGHT_TEXT }}</div>
    </footer>
  </section>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import axios from 'axios';
import constants from '@/utils/en-US-Admin.json';
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import Swal from 'sweetalert2';
import { API_BASE_URL } from '@/config/api.config';

export default defineComponent({
  name: "Edit-profile",
  data() {
    const profileImage = localStorage.getItem('profile_image');
    const baseUrl = `${API_BASE_URL}`;
    return {
      constants,
      firstname: localStorage.getItem('firstname'),
      lastname: localStorage.getItem('lastname'),
      email: localStorage.getItem('email'),
      profile_image: profileImage ? `${baseUrl}${profileImage}` : '',
      originalImage: profileImage ? `${baseUrl}${profileImage}` : '',
      selectedFile: null as File | null,
      imageSrc: '',
      errMsg: '',
      emailError: ''
    }
  },
  computed: {
    imageUrl(): string {
      return this.profile_image || require('@/assets/images/img_avatar.png');
    },
  },
  components: {
    adminHeader,
    adminNavigation
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn !== "true") {
      next({ name: 'Login' });
    } else {
      next();
    }
  },
  methods: {
    handleFileUpload(event: any) {
      const target = event.target as HTMLInputElement;
      if (target && target.files && target.files.length > 0) {
        this.selectedFile = target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = (e) => {
          if (e.target && typeof e.target.result === 'string') {
            this.imageSrc = e.target.result;
            return this.profile_image = this.imageSrc
          }
        }
      }
    },
    async updateProfile(imageFile: any) {

      this.emailError = '';
      
      if (!this.firstname || !this.lastname || !this.email) {
        this.errMsg = 'All fields are required';
        return;
      }
      try {
        const formData = new FormData();

        if (this.firstname !== null) {
          formData.append('first_name', this.firstname);
        }

        if (this.lastname !== null) {
          formData.append('last_name', this.lastname);
        }

        if (this.email !== null) {
          formData.append('email', this.email);
        }
        if (this.selectedFile) {
          formData.append('profile_image', this.selectedFile);
        }

        const adminId = localStorage.getItem('admin_id');
        if (!adminId) {
          throw new Error('Admin ID not found');
        }
        const response = await axios.put(`${API_BASE_URL}/update-admin/${adminId}/`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        });
        if (response.status === 200) {
          
          if (response.data.first_name) localStorage.setItem('firstname', response.data.first_name);
          if (response.data.last_name) localStorage.setItem('lastname', response.data.last_name);
          if (response.data.username) localStorage.setItem('email', response.data.username);
          if (response.data.profile_image) localStorage.setItem('profile_image', response.data.profile_image);
          Swal.fire({
          icon: 'success',
          title: 'Profile updated successfully',
          showConfirmButton: false,
          timer: 1500
        });
          setTimeout(() => {
            window.location.reload();
            }, 1000);
          
        }
      } catch (error: any) {
    console.error('Error updating profile:', error);
    // Check if the error is from the API response and contains email validation error
    if (error.response && error.response.data && error.response.data.email) {
      this.emailError = error.response.data.email[0]; // Set the email error message
    }
  }
    },
    cancel() {
      console.log('Cancel button clicked');
      this.firstname = localStorage.getItem('firstname') || '';
      this.lastname = localStorage.getItem('lastname') || '';
      this.email = localStorage.getItem('email') || '';
      this.profile_image = this.originalImage;
      this.selectedFile = null;
      this.errMsg = '';
      this.emailError = '';
    }
  }
});
</script>